import { Button } from '@mui/material'
import { InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

/**
 * @description
 * メールアドレス変更後に表示するモーダル
 */
export const EmailAddressSettingCompleteModal: Organism<{
  open: boolean
  onClose: () => void
}> = ({ open, onClose }) => {
  const { t } = useTranslation('emailAddressSettings')
  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={t('updateSuccess')}
      content={t('updateSuccessDesc')}
      buttons={
        <Button
          sx={{ minWidth: 212 }}
          variant="contained"
          color="primary"
          size="large"
          onClick={onClose}
        >
          {t('back')}
        </Button>
      }
    />
  )
}
